module.exports = __webpack_public_path__ + "img/world_normal_menu.9bd36ffb.png";